export const GET_RESULTS_REQUEST = "browse/GET_RESULTS_REQUEST";
export const GET_RESULTS_SUCCESS = "browse/GET_RESULTS_SUCCESS";
export const GET_RESULTS_FAILURE = "browse/GET_RESULTS_FAILURE";
export const CHANGE_SORT = "browse/CHANGE_SORT";
export const SET_SEARCH = "browse/SET_SEARCH";
export const SET_PAGE = "browse/SET_PAGE";
export const SET_FILTERS = "browse/SET_FILTERS";
export const CLEAR_FILTERS = "browse/CLEAR_FILTERS";
export const TOGGLE_FILTER_CATEGORY = "browse/TOGGLE_FILTER_CATEGORY";